import React from 'react';
import { Radio, DatePicker } from 'antd';
import './index.scss';
import moment, { Moment } from 'moment';
class ScheduledPublishTime extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    public handleDateChange = (val: Moment | null) => {
        if (val) {
            try {
                this.props.releaseTimeChange(val.format('YYYY-MM-DD HH:mm:ss'));
            } catch (error) {
                console.error('时间格式化出错:', error);
                this.props.releaseTimeChange('');
            }
        } else {
            this.props.releaseTimeChange('');
        }
    };
    public disabledDate = (current: Moment) => {
        const now = moment();
        const diff = moment(current.format('YYYY-MM-DD')).diff(now, 'days');
        return diff > 14 || diff < 0;
    }
    componentDidMount(): void {
        this.props.releaseTypeChange(1);
        this.props.releaseTimeChange('');
    }
    public render() {
        const { releaseType } = this.props;

        return (
            <div className="scheduled-publish-time">
                <div className="title">发布时间 </div>
                <Radio.Group
                    value={releaseType}
                    onChange={e => {
                        if (e.target.value === 1) {
                            this.props.releaseTimeChange('');
                        } else if (e.target.value === 2) {
                            this.props.releaseTimeChange(moment().add(1, 'hours').valueOf());
                        }
                        this.props.releaseTypeChange(e.target.value);
                    }}
                    options={[
                        { value: 1, label: '立即发布' },
                        { value: 2, label: '定时发布' }
                    ]}
                />
                {releaseType === 2 && (
                    <DatePicker
                        showTime={{ format: 'HH:mm' }}
                        format="YYYY-MM-DD HH:mm"
                        disabledDate={this.disabledDate}
                        value={
                            this.props.releaseTime
                                ? moment(this.props.releaseTime)
                                : null
                        }
                        onOk={this.handleDateChange}
                        onChange={this.handleDateChange}
                    />
                )}
                {releaseType === 2 && <span className="release-time-text">
                    (仅支持14天内的定时发布,可在内容管理和App端编辑此定时。)
                    </span>}
            </div>
        );
    }
}
export default ScheduledPublishTime;
